var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('VueChart',{style:(_vm.myStyles),attrs:{"chart-type":_vm.chartType,"chart-data":_vm.value,"options":_vm.options}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }